import React from 'react'
import FormFieldset from 'components/UI/AsideModal/Form/FormFieldset'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import asideModalStore from 'Stores/asideModalStore'
import Textarea from 'components/ContentBox/Global/Textarea/Textarea'
import { observer } from 'mobx-react'

const Details = () => {
  const { modalValues, changeValue, check } = asideModalStore
  return (
    <FormFieldset>
      <FormField>
        <FormLabel isRequired>Name:</FormLabel>
        <FormInput isError={check('name')}>
          <input
            placeholder='Name'
            type='text'
            value={modalValues.name || ''}
            onChange={(e) => changeValue(e.target.value, 'name')}
          />
        </FormInput>
      </FormField>
      <FormField>
        <FormLabel isRequired>Telephone:</FormLabel>
        <FormInput isError={check('phone')}>
          <input
            placeholder='Phone number'
            type='text'
            value={modalValues.phone || ''}
            onChange={(e) => changeValue(e.target.value, 'phone')}
          />
        </FormInput>
      </FormField>
      <FormField>
        <FormLabel isRequired>Email</FormLabel>
        <FormInput isError={check('email')}>
          <input
            placeholder='Template name'
            type='email'
            value={modalValues.email || ''}
            onChange={(e) => changeValue(e.target.value, 'email')}
          />
        </FormInput>
      </FormField>
      <FormField>
        <FormLabel>Status:</FormLabel>
        <FormInput isError={check('status_lead')}>
          <SelectCustom
            placeholder={'Source'}
            apiLinkCRM={'integration/lead_statuses_list'}
            sortKey='name'
            isDisabled
            valueID={modalValues.status_lead}
            onChange={(o) => changeValue(o.id, 'status_lead')}
            error={check('status_lead')}
          />
        </FormInput>
      </FormField>
      <FormField>
        <FormLabel>Lead number</FormLabel>
        <FormInput isError={check('lead_name')}>
          <input
            placeholder='Lead number'
            type='text'
            disabled
            value={modalValues.lead_name || ''}
            onChange={(e) => changeValue(e.target.value, 'lead_name')}
          />
        </FormInput>
      </FormField>
      <FormField>
        <FormLabel>A comment:</FormLabel>

        <Textarea
          onChange={changeValue}
          stateName='comment'
          error={check('comment')}
          value={modalValues.comment || ''}
          placeholder={'A comment'}
        />
      </FormField>
    </FormFieldset>
  )
}

export default observer(Details)
